import React from 'react';
import classnames from 'classnames';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui';
import { NeuroMessage } from '@ignitesales/neuro-application';

const RestartModal = ({ newGuideUrl, onClose, show }) => {
  const cssBEM = 'restartModal';
  const classes = classnames(cssBEM, 'modal--dialog');

  return (
    <Modal
      className={classes}
      show={show}
      title={<NeuroMessage id="restartModal.title" />}
      onClose={onClose}
      nodeId="root"
      closeBtn={<i className="fa fa-close" role="img" aria-label="Close" />}
    >
      <section>
        <NeuroMessage id="restartModal.new" tagName="h1" />
      </section>
      <div className={`${cssBEM}__footer`}>
        <button onClick={onClose} className="btn btn--outline">
          <NeuroMessage id="restartModal.cancel" />
        </button>
        <a href={newGuideUrl} className="btn btn-primary">
          <NeuroMessage id="restartModal.confirm" />
        </a>
      </div>
    </Modal>
  );
};

export default RestartModal;
